import { useQuery } from 'react-query';
import { httpService } from '../../../../../services/http.service';
import { BASE_URL } from '../../../../../constants/endpoints';
import { PAYMENT_STATUS } from '../consts';
import { IBillItem, PaymentMethods } from '../../../types';
import { IServerErrorResponse } from '../../../../../types';
import { validateFeatureFlag } from '../../../../../services/featureFlagService';
import { FEATURE_FLAG } from '../../../../../constants/general';

export interface IPaymentMethods {
    lastUsed: string,
    methods: [
        {
            methodType: PaymentMethods,
            status: string,
            expectedArrival: string,
            lastUsed: Date | string
            statusReason?: string
        }
    ]
}

interface IProps {
    customerId: string;
    accountExternalId: string;
    billId: string;
    onSuccess?: () => void;
    onError?: (msg: string) => void;
}

const getPaymentMethods = async ({ customerId, accountExternalId, billId }: IProps) => {
  const { data } = await httpService.get((`${BASE_URL}/api/v2/user/${customerId}/${accountExternalId}/bill/${billId}/paymentMethods`));
  return data as IPaymentMethods;
};
const getBillData = async ({ customerId, accountExternalId, billId }: IProps) => {
  const { data } = await httpService.get((`${BASE_URL}/api/v1/user/${customerId}/${accountExternalId}/bill/${billId}`));
  return data as IBillItem;
};
export const useFetchInitialData = ({
  customerId, accountExternalId, billId, onSuccess, onError,
}: IProps) => useQuery(
  'useFetchInitialData',
  async () => {
    const paymentMethodsResponse = await getPaymentMethods({ customerId, accountExternalId, billId });
    const filteredPaymentMethods = paymentMethodsResponse.methods.filter((method) => (method.methodType === PaymentMethods.CHECK && validateFeatureFlag(FEATURE_FLAG.MAIL_CHECK))
          || (method.methodType === PaymentMethods.WIRE && validateFeatureFlag(FEATURE_FLAG.DOMESTIC_WIRE_OUT))
          || (method.methodType === PaymentMethods.INTERNATIONAL_WIRE && validateFeatureFlag(FEATURE_FLAG.INTERNATIONAL_WIRE_OUT))
          || (method.methodType === PaymentMethods.ACH)); // ACH is not hidden behind feature flag
    const paymentMethods = { ...paymentMethodsResponse, methods: filteredPaymentMethods } as IPaymentMethods;
    const isSomeMethodAvailable = paymentMethods.methods.some(method => method.status === PAYMENT_STATUS.VALID);
    const billData = await getBillData({ customerId, accountExternalId, billId });
    return { billData, paymentMethods, isSomeMethodAvailable };
  },
  {
    enabled: true,
    refetchOnWindowFocus: false,
    cacheTime: 5,
    retry: false,
    onError(e: IServerErrorResponse) {
      if (onError) onError(e?.response?.data?.errors[0].localizedMessage);
    },
    onSuccess() {
      if (onSuccess) onSuccess();
    },

  },
);
